import PropTypes from "prop-types";

import { ErrorIcon } from "@/components/data-display/icon";

function OtpError({ errorMessage }) {
  return (
    <div
      className="bg-[rgba(255, 66, 66,0.06)] mt-[1.875rem] flex h-[2.5rem] w-full items-center justify-center rounded-[0.625rem] sm:max-w-[29rem] lg:h-[3.125rem]"
      style={{ backgroundColor: "rgba(255, 66, 66,0.06)" }}
    >
      <div className="flex flex-row items-center space-x-[1rem] text-center text-error-color">
        <ErrorIcon />
        <p>{errorMessage}</p>
      </div>
    </div>
  );
}

OtpError.defaultProps = {
  errorMessage: "Wrong OTP number. Please try again",
};

OtpError.propTypes = {
  errorMessage: PropTypes.string,
};

export default OtpError;
